import { CartLineItemInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';

export interface CartLineItemAttributesProps {
  attributes: CartLineItemInterface['attributes'];
}

export function CartLineItemAttributes({ attributes }: CartLineItemAttributesProps) {
  if (!attributes || isEmpty(attributes)) {
    return null;
  }

  return (
    <div>
      {attributes
        .filter((item) => !item.key.startsWith('_')) // Skip attributes starting with "_"
        .map((item, key) => (
          <div className="flex gap-1 text-sm" key={key}>
            <span className="font-semibold first-letter:uppercase">{item.key}:</span>
            <span>{item.value}</span>
          </div>
        ))}
    </div>
  );
}

export default CartLineItemAttributes;
